module.exports = Odigeo.Widget.extend({
    modelClass: Odigeo.Model.extend({
        init: function() {
            this.started = false;
            this.constantTags = [];
        },
    }),
    viewClass: Odigeo.View.extend({
        events: {},

        init: function() {},
    }),
    nameInWindow: '__insp',

    insertRecorderScript: function() {
        var insp = document.createElement('script');
        insp.type = 'text/javascript';
        insp.async = true;
        insp.id = 'inspsync';
        insp.src = ('https:' === document.location.protocol ? 'https' : 'http') + '://cdn.inspectlet.com/inspectlet.js';
        var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(insp, x);
    },

    init: function() {
        var enabled = !Odigeo._.isEmpty(this.options.recorderId);
        this.options.enabled = enabled;
        if (enabled) {
            this.options = Odigeo.parseOptions(this.options);
            window[this.nameInWindow] = window[this.nameInWindow] || [];
            window[this.nameInWindow].push(['wid', this.options.recorderId]);
        }
    },

    bindVolatileEvents: function() {
        var bindEvents = {
            'payment-manager:showErrors': function(data) {
                return [data];
            },
            'payment-manager:showErrorsResume': function() {
                return Array.prototype.slice.call(arguments);
            },
            'payment-manager:noPaymentMethodsAvailable': ['noPaymentMethodsAvailable_BrokenFLow'],
            'payment-manager:updateCardMethod': ['updateCardMethod'],
            'payment-manager:ready': ['paymentManagerReady'],
            'payment-manager:confirmationReady': function(data) {
                return [{booking: data.bookingstatus}];
            },
        };
        Odigeo._.map(bindEvents, function(val, key) {
            Odigeo.on(key, Odigeo._.partial(
                Odigeo._.delay,
                Odigeo._.bind(function(data) {
                    var result;
                    var args = [].slice.call(arguments, 1);
                    result = Odigeo._.isFunction(data) ? data(args) : data;
                    [this.trackTags, this.trackPairs][Number(Odigeo._.isObject(result))].apply(this, result);
                }, this, val),
                0
            ));
        }, this);
    },

    bindStaticEvents: function() {
        var analyticsActions = [
            /payment_details/,
            /payment_details_error/,
            /confirm_purchase/,
            /insurances_information/,
            /service_options_information/,
            /reject_solutions/,
            /booking_status/,
        ];
        Odigeo.on('page:afterSwitch', Odigeo._.partial(Odigeo._.delay, Odigeo._.bind(function() {
            this.trackVirtualPage();
        }, this), 0));
        Odigeo.on('analytics:tracking', Odigeo._.partial(Odigeo._.delay, Odigeo._.bind(function(obj) {
            if (Odigeo._.isObject(obj) && Odigeo._.isObject(obj.data)) {
                var data = obj.data;
                var result = {};
                var matches;

                if (data.action) {
                    matches = Odigeo._.some(analyticsActions, function(action) {
                        return action.test(data.action);
                    });
                    if (matches) {
                        result[data.action] = data.label;
                        this.trackPairs(result);
                    }
                } else if (obj.type && obj.type === 'trackVirtualPage' && Odigeo._.isObject(data.error)) {
                    this.trackTags(data.error.message);
                }
            }
        }, this), 0));
    },

    start: function() {
        if (this.options.enabled) {
            if (!this.model.started) {
                this.insertRecorderScript();
                this.model.started = true;
                this.trackPairs(Odigeo._.chain(this.options).omit('recorderId', 'recorderVersion', 'enabled').value());
                this.bindStaticEvents();
            }
            this.bindVolatileEvents();
        }
    },

    _executeCommand: function(cmd, argument) {
        window[this.nameInWindow].push(Odigeo._.isUndefined(argument) ? [cmd] : [cmd, argument]);
    },
    trackPairs: function(pairs) {
        if (this.options.enabled) {
            this._executeCommand('tagSession', pairs);
        }
    },
    trackTags: function() {
        if (this.options.enabled) {
            this._executeCommand('tagSession', ([].slice.call(arguments)).join(' '));
        }
    },
    trackVirtualPage: function() {
        if (this.options.enabled) {
            this._executeCommand(['virtualPage']);
        }
    },

    options: {},
});
